import { HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, finalize, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/services/apiService';
import { AuthService } from 'src/services/auth.service';
import { SweetAlertService } from 'src/services/sweetAlertService';
import jwt_decode from "jwt-decode";

@Component({
  selector: 'app-investment-dashboard',
  templateUrl: './investment-dashboard.component.html',
  styleUrls: ['./investment-dashboard.component.css']
})
export class InvestmentDashboardComponent {

  currentServices: any[] = [];
  archiveService: any[] = [];
  oldArchiveService: any[] = [];
  oldCurrentServices: any[] = [];
  mainPath = "" // قراءة القيمة من environment
  SectionId = "" // قراءة القيمة من environment

  compaines: any[] = [];
  isLoading: boolean = true;

  companyLoading: boolean = true;

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    private sweetAlertService: SweetAlertService,
    private authService: AuthService
  ) {

    this.mainPath= environment.MainPath;
    this.SectionId= environment.SectionId;

    var token = this.authService.getToken();

    var decoded = jwt_decode(token!) as any;
    var role=decoded.role;

    if(role?.includes('PROVIDER') && role?.includes('HEID_MOIN')){
      location.href='/'+this.mainPath+'/ControlPanel/Exemptions';
    }else if(role?.includes('PROVIDER') && role?.includes('FO_MOIN')){
      location.href='/'+this.mainPath+'/ControlPanel/Recipt';
    }

    // Use forkJoin to combine both observables and finalize to update isLoading
    forkJoin([this.fillCurrentServicesForConsumer()])
      .pipe(finalize(() => this.isLoading = false))
      .subscribe();


      
    setTimeout(() => {
      
      const tabs = document.querySelectorAll('[data-role="tab"]'),
      tabContents = document.querySelectorAll(".tab-panel");
    
    tabs.forEach((tab:any) => {
      tab.addEventListener("click", () => {
        const target = document.querySelector(tab?.dataset?.target);
    
        tabContents.forEach((tc) => {
          tc.classList.remove("is-active");
        });
        target.classList.add("is-active");
    
        tabs.forEach((t) => {
          t.classList.remove("is-active");
        });
        tab.classList.add("is-active");
      });
    });

    }, 2000);

    this.getCompanies();
    this.fillOldRequest();

  }



  getCompanies() {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Accept-Language': 'ar-JO',
      
      'Authorization': this.authService.getToken() != undefined ? `Bearer ${this.authService.getToken()}` : '',
    });

    var request= this.apiService.get('Moin/GetCompanyAuthorizationData', `${environment.govnet}`, headers);

    request.subscribe(response=>{
      var data = response.data;
      this.compaines = data;
      this.companyLoading=false;
    });

  }

  fillCurrentServicesForConsumer() {


    var link="carboncopies/GetCurrentServicesForConsumer?SortOrder=desc";

    if(environment.production){
      link+="&EntityId="+this.SectionId;
    }

    return this.apiService.get(link)
      .pipe(
        tap(response => {
          if(response.statusCode == 200) {
          var requests = response.data as any[];
          var data = requests as any;
          this.currentServices = data.items;
        }
        }),
      );
  }

  runFillCurrentServicesForConsumer(){
    this.isLoading=true;

    this.fillCurrentServicesForConsumer().subscribe(response=>{
      this.isLoading=false;
    });
  }

  fillArchiveServicesForConsumer() {

    this.isLoading=true;

    var link="carboncopies/GetArchivedServicesForConsumer?SortOrder=desc";

    if(environment.production){
      link+="&EntityId="+this.SectionId;
    }

     var request = this.apiService.get(link);

     request.subscribe(response=>{

      var requests = response.data as any[];
      var data = requests as any;
      this.archiveService = data.items;

      this.isLoading=false;
     });

      
  }

  fillOldRequest(){

    var oldRequests = this.apiService.get(`moin/GetOldRequest`,environment.govnet);
    
    oldRequests.subscribe(response=>{

      var items=response.data;

      var resp=items as any[];

      this.oldArchiveService=resp.filter(x=>x.status==0 ||x.status==9);

      this.oldCurrentServices=resp.filter(x=>x.status!=0 && x.status!=9);

    });
  }

  showRejectedType(id:string){
    var archiveService=this.archiveService.filter(x=>x.id==id)[0];

    this.sweetAlertService.ShowAlert('info',archiveService.rejectReason??"");
  }

  openOldApplicant(id:string){
      window.open(`${environment.oldWebsite}/ar/portal/in?token=${this.authService.getToken()}&model=requests&id=${id}`);
  }


}

